import { render, staticRenderFns } from "./TalentLeftMenu.vue?vue&type=template&id=e31826f2&"
import script from "./TalentLeftMenu.vue?vue&type=script&lang=js&"
export * from "./TalentLeftMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports